import "@twilight-toolkit/ui/styles/base.css"
import "highlight.js/styles/github-dark.css"
import "katex/dist/katex.min.css"
import type { NextPage } from "next"
import { ThemeProvider } from "next-themes"
import type { AppProps } from "next/app"
import { useRouter } from "next/router"
import Script from "next/script"
import NextNprogress from "nextjs-progressbar"
import type { ReactElement, ReactNode } from "react"
import { Provider as ReduxProvider } from "react-redux"

import store from "~/store"

import "~/styles/global.css"
import { useViewTransitionRouter } from "~/utilities/viewTransition"

export type NextPageWithLayout = NextPage & {
	layout?: (page: ReactElement) => ReactNode
}

type AppPropsWithLayout = AppProps & {
	Component: NextPageWithLayout
}

function App({ Component, pageProps }: AppPropsWithLayout) {
	const router = useRouter()
	const getLayout = Component.layout ?? ((page) => page)

	// Enable view transitions for browser back/forward navigation
	useViewTransitionRouter(router)

	return (
		<div>
			{/* Analytics Script */}
			<Script
				async
				defer
				data-do-not-track="true"
				data-domains="lipeng.ac"
				data-website-id="e3d939fa-1fa0-4c06-adb1-1081d6b6686e"
				src="https://analytics.ouorz.com/analytics.js"
			/>
			{/* NProgress Loading Progress Bar */}
			<NextNprogress
				color="#d4d4d8"
				height={2}
				options={{ showSpinner: false }}
			/>
			{/* Next-Themes Theme Provider */}
			<ThemeProvider attribute="class" defaultTheme="light" enableSystem={true}>
				{/* Redux Store Provider */}
				<ReduxProvider store={store}>
					<div className="min-h-screen animate-appear bg-gbg dark:bg-neutral-900 dark:text-white">
						{getLayout(<Component {...pageProps} />)}
					</div>
				</ReduxProvider>
			</ThemeProvider>
		</div>
	)
}

export default App
